import React from "react";
import MainLayout from "./MainLayout";
import OpenEnrollment from "../common/MainContent/Home/OpenEnrollment";

const OpenEnrollmentPage = (props) => <MainLayout component={OpenEnrollment} />;

export default OpenEnrollmentPage;
